/* Click-to-load facade for YouTube embeds inside the product description.
   sections/product.liquid rewrites the iframes' src= to data-yt-src= at render
   time, so the browser never boots YouTube's player (~1MB JS / ~500ms main
   thread) during page load. This script swaps each inert iframe for a poster +
   play button occupying exactly the same box; the real youtube-nocookie iframe
   is only created when the visitor activates it (click / Enter / Space via a
   native <button>). If a data-yt-src doesn't look like a YouTube embed, the
   original iframe is restored untouched. */
(function () {
  'use strict';

  function videoId(src) {
    var m = src.match(/\/embed\/([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }

  function activate(shell, iframe, src) {
    var url = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1&playsinline=1';
    iframe.setAttribute('src', url);
    iframe.removeAttribute('data-yt-src');
    iframe.removeAttribute('loading'); /* user asked for it — load now */
    shell.replaceWith(iframe);
    try { iframe.focus(); } catch (e) { /* focus is a nicety */ }
  }

  function build(iframe) {
    var src = iframe.getAttribute('data-yt-src') || '';
    var id = videoId(src);
    if (!id) {
      /* not a recognisable YouTube embed — behave exactly like before */
      iframe.setAttribute('src', src);
      iframe.removeAttribute('data-yt-src');
      return;
    }

    var shell = document.createElement('div');
    shell.className = 'yt-lite';
    /* Take over the exact box the iframe occupied. Descriptions wrap the
       iframe absolutely inside a fixed-ratio container (inline style); bare
       width/height embeds get an equivalent aspect-ratio box instead. */
    var inlineStyle = iframe.getAttribute('style');
    if (inlineStyle) shell.setAttribute('style', inlineStyle);
    if (!inlineStyle || inlineStyle.indexOf('position') === -1) {
      var w = parseInt(iframe.getAttribute('width'), 10);
      var h = parseInt(iframe.getAttribute('height'), 10);
      shell.style.aspectRatio = w > 0 && h > 0 ? w + ' / ' + h : '16 / 9';
      shell.style.width = '100%';
      if (w > 0) shell.style.maxWidth = w + 'px';
    }

    var title = iframe.getAttribute('title') || 'Product video';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'yt-lite__btn';
    btn.setAttribute('aria-label', 'Play video: ' + title);

    var img = document.createElement('img');
    img.className = 'yt-lite__poster';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    /* i.ytimg.com is a static image host — no script, no player boot */
    img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';

    var badge = document.createElement('span');
    badge.className = 'yt-lite__play';
    badge.setAttribute('aria-hidden', 'true');

    btn.appendChild(img);
    btn.appendChild(badge);
    shell.appendChild(btn);
    btn.addEventListener('click', function () { activate(shell, iframe, src); });

    iframe.replaceWith(shell);
  }

  function init() {
    var frames = document.querySelectorAll('iframe[data-yt-src]');
    for (var i = 0; i < frames.length; i++) build(frames[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
